import { dateValueTransition } from "./date.js";
/** Canonical range transition: bounds/filter invalid dates and keep end >= start. */
export function dateRangeValueTransition(value, options = {}) {
    const normalize = (iso) => {
        if (iso === null)
            return null;
        const canonical = dateValueTransition({ type: "select", iso }, options.minIso, options.maxIso);
        if (canonical === null || options.accepts?.(canonical) === false)
            return null;
        return canonical;
    };
    const start = normalize(value.start);
    let end = normalize(value.end);
    if (start !== null && end !== null && end < start)
        end = start;
    return { start, end };
}
/** Modal date-range draft policy. Incomplete drafts close without committing. */
export function dateRangeDraftTransition(state, intent, options = {}) {
    if (intent.type === "open") {
        const committed = dateRangeValueTransition(intent.committed, options);
        return { state: { committed, draft: committed, open: true }, commit: undefined, restoreFocus: false };
    }
    if (intent.type === "select") {
        return { state: { ...state, draft: dateRangeValueTransition(intent.value, options) }, commit: undefined, restoreFocus: false };
    }
    if (intent.type === "confirm") {
        const complete = state.draft.start !== null && state.draft.end !== null;
        const next = complete ? state.draft : state.committed;
        return {
            state: { committed: next, draft: next, open: false },
            commit: complete ? next : undefined,
            restoreFocus: true,
        };
    }
    return {
        state: { committed: state.committed, draft: state.committed, open: false },
        commit: undefined,
        restoreFocus: true,
    };
}
